export enum LiquidationSortMethod {
  Positions = 'Positions',
  LiqPrice = 'Liq. Price',
  MarkPrice = 'Mark Price',
  Size = 'Size',
  Bonus = 'Bonus',
  Action = 'Action',
}
